<template>
  <v-list-tile :key="plot.Id">
    <v-list-tile-content>
      <v-list-tile-title>{{ plot.PlotName || plot.Id }}</v-list-tile-title>
      <v-list-tile-sub-title>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-layout row wrap>
              <!-- <v-flex xs12 class="plot-label-row">
                <span class='text--primary plot-row-label'>PlotID: </span>{{ plot.Id }}
              </v-flex> -->
              <v-flex xs12 class="plot-label-row">
                <span class='text--primary'>Plot Type: </span>{{ plot.PlotType }}
              </v-flex>
              <v-flex xs12 class="plot-label-row">
                <span class='text--primary'>Community Type: </span>{{ plot.CommunityType }}
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 offset-sm2>
            <v-layout row wrap>
              <v-flex xs12><span class='text--primary'>{{ plot.ChildrenPlots.length }}</span> Subplots</v-flex>
              <v-flex xs12><span class='text--primary'>{{ plot.Specimena.length }}</span> Specimena</v-flex>
              <v-flex xs12><span class='text--primary'>{{ plot.Surveys.length }}</span> Surveys</v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm1>
            <v-btn small round v-on:click="$router.push(`/vegetativemonitoring/plot/${plot.Id}`)">View</v-btn>
          </v-flex>
        </v-layout>
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action v-if="pad">
      <div class="dropdown-pad"></div>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
  export default {
    props: {
      plot: {
        type: Object,
        required: true,
      },
      pad: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      plotName() {
        if (this.plot.PlotName == null) {
          return `Plot #${this.plot.ImportedPlotId}`
        }
        return `${this.plot.PlotName}`
      },
    },
  }
</script>

<style scoped>
  .plot-label-row {
    margin-left: 30px;
  }

  .dropdown-pad {
    width: 26px;
  }
</style>